<app-mens-intimate-wash
  htmlTitle="<strong>Essential: Support Full Recovery</strong>"
  question="Would you like to include the Penile Bacteria Wash with your treatment?"
>
  <p class="mb-4">
    In addition to your medicated treatment to clear BV-related bacteria, we recommend adding our specially formulated
    <strong>Penile Bacteria Wash</strong>. This gentle, pH-balanced wash is designed specifically for intimate skin to
    help cleanse bacteria that may remain after treatment.
  </p>
  <p class="mb-4">
    Using it daily for 5 days supports a more thorough recovery and promotes a clean, healthy environment — helping you
    feel confident and refreshed throughout the healing process.
  </p>
</app-mens-intimate-wash>
